import { default as React, type FC } from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

import logoRed from '../../assets/images/dazn.link-red.png';
import logoYellow from '../../assets/images/dazn.link-yellow.png';
import logoBlue from '../../assets/images/dazn.link.png';
import { APP_NAME } from '../../config/constants';
import { routes } from '../../pages/routes';

const navRoutes = [routes.dashboard, routes.about];

export const Header: FC = () => {
  const [isMouseOverLogo, setIsMouseOverLogo] = React.useState(false);
  const mouseOverLogo = Math.floor(Math.random() * 2) > 0 ? logoBlue : logoRed; // eslint-disable-line @typescript-eslint/no-magic-numbers

  return (
    <Navbar variant={'dark'} bg={'dark'} expand={'lg'}>
      <Navbar.Brand
        href="/"
        onMouseLeave={() => {
          setIsMouseOverLogo(false);
        }}
        onMouseEnter={() => {
          setIsMouseOverLogo(true);
        }}
      >
        <img src={isMouseOverLogo ? mouseOverLogo : logoYellow} alt="Logo" className="navbar-brand-logo" />
        <span className="navbar-brand-title">{APP_NAME}</span>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-auto">
          {navRoutes.map((route, idx) => (
            <NavLink key={idx} to={route.path} className="nav-link" activeClassName="active" exact={true}>
              {route.title}
            </NavLink>
          ))}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};
